export default __webpack_public_path__ + "static/media/Marc-Olivier-Laramee.ad412a7e.png";